import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				overflowY: "scroll"
			},
			title: {
				color: theme.palette.primary.contrastText,
				fontSize: 18,
				fontWeight: 500,
				marginTop: 10,
				padding: "0px 16px"
			}
		}),
	{
		name: "PromotionDetailPage",
		index: 1
	}
);

export default useStyles;
